<template>
  <custom-dialog append-to-body width="500px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" :rules="rules" :validate-on-rule-change="false" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('c_pwd1_jiu_mi_ma')" prop="originalPwd">
              <el-input v-model="form.originalPwd" type="password"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p style="margin-bottom: 20px; font-size: 12px; color: #4d4d4d;">{{$t('c_pwd1_mmcdwbxbhszfhzmrylz')}}</p>
            <el-form-item :label="$t('c_pwd1_xin_mi_ma')" prop="newPwd">
              <el-input v-model="form.newPwd" type="password" :placeholder="$t('c_pwd1_qsrxmm')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('c_pwd1_qrxmm')" prop="confirmPwd">
              <el-input v-model="form.confirmPwd" type="password" :placeholder="$t('c_pwd1_qzcsrxmm')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('com_cancel') }}</el-button>
      <el-button type="warning" @click="changePwd">{{ $t('com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

// c_pwd1_mmcdwbxbhszfhzmrylz: 密码长度8-16位，必须包含数字、符号、字母任意两种// c_pwd1_jiu_mi_ma: 旧密码// c_pwd1_xin_mi_ma: 新密码// c_pwd1_qsrxmm: 请输入新密码// c_pwd1_qrxmm: 确认新密码// c_pwd1_qzcsrxmm: 请再次输入新密码// c_pwd1_jmmbnwk: 旧密码不能为空// c_pwd1_xmmbnwk: 新密码不能为空// c_pwd1_mmcdwgzf: 密码长度为8 - 16个字符// c_pwd1_bxbhszfhzmrylz: 必须包含数字、符号、字母任意两种// c_pwd1_qrmmbnwk: 确认密码不能为空// c_pwd1_lcsrmmbyz: 两次输入密码不一致

export default {
  mixins: [dialogMixins],
  data() {
    // 密码验证
    const validatePass = () => {};
    const validatePass2 = () => {};
    return {
      appName: '',
      parentName: '',
      form: {
        originalPwd: '',
        newPwd: '',
        confirmPwd: ''
      },
      langKeyId: '',
      // 所选分组list
      treeOptionList: [],
      validatePass: validatePass,
      validatePass2: validatePass2,
    };
  },
  computed: {
    rules() {
      return {
        originalPwd: {
          required: true,
          message: this.$t('c_pwd1_jmmbnwk'),
        },
        newPwd: {
          required: true,
          validator: this.validatePass,
          trigger: 'blur'
        },

        confirmPwd: {
          required: true,
          validator: this.validatePass2,
          trigger: 'blur'
        }
      };
    }
  },
  mounted() {
    this.mergeLanguage(null, 'portal_change_pwd_dialog');},
  methods: {
    i18nCallback: function () {
      this.rules.newPwd.validator = (rule, value, callback) => {
        const reg = /(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/;
        if (!value) {
          callback(new Error(this.$t('c_pwd1_xmmbnwk')));
        } else if (value.toString().length < 8 || value.toString().length > 16) {
          callback(new Error(this.$t('c_pwd1_mmcdwgzf')));
        } else if (!reg.test(value.toString())) {
          callback(new Error(this.$t('c_pwd1_bxbhszfhzmrylz')));
        } else {
          callback();
        }
      };
      this.rules.confirmPwd.validator = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('c_pwd1_qrmmbnwk')));
        } else if (value !== this.form.newPwd) {
          callback(new Error(this.$t('c_pwd1_lcsrmmbyz')));
        } else {
          callback();
        }
      };
    },
    // 修改登录密码
    changePwd: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$postJSON(apis.UpdatePwd, this.form, true)
          .then(() => {
            this.visible = false;
            this.$message({
              message: this.$t('com_handle_success'),
              type: 'success'
            });
          })
          .catch(() => {});
      });
    }
  }
};
</script>

<style lang="scss"></style>
